/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JobOutcomeNextId } from "./JobOutcomeNextId";
import { JobOutcomeNextUrl } from "./JobOutcomeNextUrl";
import { JobOutcomeNextDownload } from "./JobOutcomeNextDownload";
import { JobOutcomeNextFiles } from "./JobOutcomeNextFiles";
import { JobOutcomeNextWait } from "./JobOutcomeNextWait";
import { JobOutcomeNextSnapshot } from "./JobOutcomeNextSnapshot";
import { JobOutcomeNextRetry } from "./JobOutcomeNextRetry";
import { JobOutcomeNextView } from "./JobOutcomeNextView";
import { JobOutcomeNextClearFilters } from "./JobOutcomeNextClearFilters";
export const JobOutcomeNext = core.serialization
    .union("type", {
    id: JobOutcomeNextId,
    url: JobOutcomeNextUrl,
    download: JobOutcomeNextDownload,
    files: JobOutcomeNextFiles,
    wait: JobOutcomeNextWait,
    snapshot: JobOutcomeNextSnapshot,
    retry: JobOutcomeNextRetry,
    view: JobOutcomeNextView,
    clearFilters: JobOutcomeNextClearFilters,
})
    .transform({
    transform: (value) => value,
    untransform: (value) => value,
});
